module.exports = __webpack_public_path__ + "img/log-out.a93ce9b3.svg";